import { customerQuotationList } from "constants/customerQuotation";

const initialState = {
  customerQuotationList: {},
};

const customerQuotation = (state = initialState, action) => {
  switch (action.type) {
    case customerQuotationList:
      return { ...state, customerQuotationList: action.payload };
    default:
      return state;
  }
};

export default customerQuotation;
